<script setup lang="ts">

import { useViewModelInstance } from '@app/MyGarage';
import { Button } from 'cv-library/src/Library/Components/Forms/Button';

const model = await useViewModelInstance();
const feature = model.carePlan.carbucksRewards;

</script>

<template>

    <div class="p-4 lg:p-6 3xl:p-8 tracking-wider
                bg-gradient-to-b dark:from-transparent dark:via-gray-900 dark:to-transparent">

        <ConciergeButton 
            v-if="model.carePlan.carbucksRewards.isConciergeEnabled"
            class="mb-10 2xl:mb-12" 
        />

        <!-- CONCIERGE ICON AND TAGLINE -->
        <div class="flex justify-start items-center gap-4 pl-14 3xl:pl-[4.5rem] pb-1 3xl:pb-2">
            <Icon name="special:concierge" class="text-3xl 3xl:text-4xl absolute bottom-1.5 left-4 3xl:left-6"/>
            <span class="text-base lg:text-lg 3xl:text-2xl">
                {{ feature.hasMessages ? 'Your Messages' : 'You Have No New Messages' }}
            </span>
        </div>

        <!-- MESSAGE LIST -->
        <div v-if="feature.hasMessages"
             class="rounded-lg overflow-hidden flex flex-col gap-px">
            <div v-for="message in feature.messages"
                 :key="message.conciergeMessageId"
                 class="flex flex-col pb-3
                        bg-gradient-to-l from-secondary-750/50 via-secondary-800/50 to-secondary-700/50 
                        text-secondary-500 brightness-[140%] hover:brightness-[155%]">
                <div :to="message.linkUrl"
                            :disabled="message.hasLink == false"
                            class="flex-1 flex items-center justify-between gap-3 lg:gap-4 3xl:gap-5
                                   p-3 3xl:p-6 !pb-0 mb-0">
                    <div class="html-content text-base lg:text-base 3xl:text-xl"
                         v-html="message.content">
                    </div>
                </div>       
                <div class="flex gap-2 lg:gap-3 3xl:gap-5 text-white 3xl:px-3">
                    <Button v-if="message.hasLink"
                            :to="message.linkUrl">
                        Show me
                    </Button>                  
                    <Button variant="text"
                            @click.prevent="feature.dismissMessage( message )">
                        Dismiss
                    </Button>
                </div>
            </div>
        </div>
            
    </div>

</template>

<style lang="scss">

    .html-content
    {
        p
        {
            margin-bottom: 0.5em;
        }
    }

</style>